import { BatchSelectionRow } from "../types";

export function matchesRequest(
  row: BatchSelectionRow | undefined,
  correlationId: string,
) {
  return (
    row?.output?.correlationId === correlationId &&
    row?.output?.status === "loading"
  );
}
